import React from 'react';
import { StyleSheet, View, Text } from 'react-native';

const SectionDivider = () => (
    <View style={styles.dividerContainer}>
        <View style={styles.line} />
    </View>
);

const styles = StyleSheet.create({
    dividerContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        marginVertical: 20,
        marginTop: 40,
    },
    line: {
        flex: 1,
        height: 2,
        backgroundColor: '#ddd',
    },
    title: {
        paddingHorizontal: 20,
        fontSize: 25,
        color: '#333',
        fontWeight: 'bold',
        backgroundColor: '#fff',
    },
});

export default SectionDivider;
